import { render, staticRenderFns } from "./file-manager.vue?vue&type=template&id=9f87e4c2&scoped=true&"
import script from "./file-manager.vue?vue&type=script&lang=js&"
export * from "./file-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f87e4c2",
  null
  
)

export default component.exports